import hexToRgb from './hexToRgb';
var confineOpacity = function confineOpacity(num) {
  return Math.max(0, Math.min(num, 1));
};
export default function alpha(color, opacity) {
  return "rgba(".concat(hexToRgb(color).join(', '), ", ").concat(confineOpacity(opacity), ")");
}